import React from 'react';
export function GuaranteeSection() {
  return <section aria-labelledby="garantia" className="bg-white" data-id="element-81" data-mp="1i4znmpm6fims">
      <div className="mx-auto max-w-xl px-4 py-5 sm:py-8" data-id="element-82" data-mp="4wb86lsv3lr6">
        <div className="rounded-xl border-2 border-energy bg-energy/10 p-4 text-center" data-id="element-83" data-mp="9ucrn7u79n36">
          <p className="font-display text-sm font-semibold leading-tight text-electric sm:text-base" data-id="element-84" data-mp="9wpfu2qjwtoo">
            Tu inversión está protegida
          </p>
          <h2 id="garantia" className="mt-0.5 font-display text-xl font-extrabold text-navy sm:text-3xl" data-id="element-85" data-mp="jrr5r0snhzsb">
            🛡️ Garantía total de 7 días
          </h2>
          <p className="mt-1.5 text-sm leading-snug text-navy/75" data-id="element-86" data-mp="sl48svkfihs4">
            Tienes 7 días para explorar los 6 tomos y los 5 bonos. Si consideras que el sistema no es adecuado para
            ti, puedes solicitar un reembolso dentro del período establecido según los términos de devolución.
          </p>
        </div>
      </div>
    </section>;
}